var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosterCreationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_9297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.30103 15.5436L4.40551 5.04436C4.4074 4.84734 4.44809 4.65263 4.52525 4.47134C4.60241 4.29005 4.71452 4.12574 4.8552 3.98779C4.99587 3.84985 5.16234 3.74096 5.3451 3.66736C5.52786 3.59376 5.72333 3.55689 5.92034 3.55884L14.9203 3.64928C15.3181 3.65329 15.698 3.81516 15.9764 4.09927C16.2548 4.38337 16.409 4.76645 16.405 5.16423L16.3006 15.6635C16.2987 15.8605 16.258 16.0552 16.1808 16.2365C16.1037 16.4178 15.9916 16.5821 15.8509 16.72C15.7102 16.858 15.5437 16.9669 15.361 17.0405C15.1782 17.1141 14.9828 17.1509 14.7857 17.149L5.7858 17.0586C5.38802 17.0545 5.00812 16.8927 4.72968 16.6086C4.45123 16.3245 4.29704 15.9414 4.30103 15.5436Z",
    stroke: "#626262",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39047 6.57395L13.3905 6.63346M7.36028 9.57368L13.3605 9.63393M7.33084 12.5733L11.0807 12.6112",
    stroke: "#626262",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_9297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 2.94922) rotate(-9.42979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosterCreationIcon);
export default __webpack_public_path__ + "static/media/poster-creation-icon.d95a7d0e7928fe7a6d21a5f68ad52c58.svg";
export { ForwardRef as ReactComponent };